import { ContouringSliceState, localContouringSelectors } from "../../contouring/contouringSlice";
import GenericSelectors from "./genericSelectors";

export class CommonContourSelectors extends GenericSelectors<ContouringSliceState, typeof localContouringSelectors> {
    constructor() {
        super(localContouringSelectors);
    }
}
